import React from 'react';

import { Status } from '@gogame/components';

import {
  STATUS_ACTIVE,
  STATUS_INACTIVE,
  STATUS_ERROR,
  STATUS_PENDING_FOR_START,
  STATUS_PENDING_FOR_APPROVAL,
  STATUS_LABELS,
} from 'scenes/SmartRules/constants';

export const getColor = (id) => {
  switch (id) {
    case STATUS_ACTIVE:
      return 'success';
    case STATUS_INACTIVE:
      return 'inactive';
    case STATUS_ERROR:
      return 'error';
    case STATUS_PENDING_FOR_START:
    case STATUS_PENDING_FOR_APPROVAL:
      return 'pending';
  }
};

const SmartRuleStatus = ({ id }) => {
  return <Status color={getColor(id)}>{STATUS_LABELS[id]}</Status>;
};

export default SmartRuleStatus;
